import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import {
  DefaultIKeyValPairAndInputStateModel,
  IKeyValPair,
  IKeyValPairAndInputStateModel,
} from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export default ApiBaseReducer<pList, IKeyValPairAndInputStateModel<pList>, Collection<IKeyValPair>>(
  ActionSubTypes.API_KULLANIMAMACLIGAYRIMENKULSAYI,
  DefaultIKeyValPairAndInputStateModel<pList>()
);
